'use client';

import { createContext, useContext, useState, type Dispatch, type SetStateAction } from 'react';

// simple context used to track if google tag manager tag has been loaded
// needed to make sure pushEvent is not called before google tag manager tag is loaded (will result in no-op)
const GTMLoadedStatusContext = createContext<{
  GTMLoaded: boolean;
  setGTMLoaded: Dispatch<SetStateAction<boolean>>;
} | null>(null);

export function useGTMLoadedStatus() {
  const context = useContext(GTMLoadedStatusContext);
  if (!context) {
    throw new Error('useGTMLoadedStatus must be used within a GTMLoadedStatusProvider');
  }
  return context;
}

export function GTMLoadedStatusProvider({ children }: { children: React.ReactNode }) {
  const [GTMLoaded, setGTMLoaded] = useState(false);

  return (
    <GTMLoadedStatusContext.Provider value={{ GTMLoaded, setGTMLoaded }}>
      {children}
    </GTMLoadedStatusContext.Provider>
  );
}
